// @flow

import React, {Component} from "react"
import {Select} from 'formsy-react-components'
import {connect} from "react-redux"
import {injectIntl} from "react-intl"
import _ from 'lodash'
import {ACTION_QUERY_COUNTRY_LIST_LOADING} from '../../constants'

import type {Country} from '../../types'

function mapStateToProps(state, ownProps) {

  const countries = state.countries
  return {
    countries
  }
}

const mapDispatchToProps = {
  queryCountries: function () {
    return {
      type: ACTION_QUERY_COUNTRY_LIST_LOADING
    }
  }
}


class CountrySelect extends Component {

  props:{
    name: string,
    value: string,
    required: boolean,
    countries: {
      data:Array<Country>
    },
    intl:{
      formatMessage: ({})=>string
    },
    queryCountries: ()=>void
  }

  componentWillMount() {
    this.props.queryCountries()
  }

  render() {

    const format = this.props.intl.formatMessage

    const singaporeFirst = (countries)=>{
      if(!countries || countries.length === 0) return []
      else{
        const sg = countries.filter((c)=>c.code === 'SG')
        return _.concat(sg, countries.filter((c)=>c.code !== 'SG'))
      }
    }

    const countries = singaporeFirst(this.props.countries.data)
    const options = countries.map(
      (c)=>
        ({
          value: c.code,
          label: c.label
        })
    )

    return (
      <Select name={this.props.name}
              label={format({id: 'input.label.country'})}
              value={this.props.value}
              options={[{value:'', label:format({id: 'input.label.country.default'})}, ...options]}
              required={this.props.required}
              {...this.props}
      >
      </Select>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CountrySelect))



// WEBPACK FOOTER //
// ./src/components/form/CountrySelect.js